import React from 'react';
import './Hero.css';
import GoogleMap from "../img/GoogleMap.png";
import iPhone from "../img/iPhone.png";
import BG from "../img/BG.png"

const Hero = () => {
    return (
        <section className="hero">
            <svg width="0" height="0" style={{position: 'absolute'}}>
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style={{stopColor: '#ff6ba9', stopOpacity: 1}} />
                        <stop offset="50%" style={{stopColor: '#a855f7', stopOpacity: 1}} />
                        <stop offset="100%" style={{stopColor: '#4d9fff', stopOpacity: 1}} />
                    </linearGradient>
                    <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style={{stopColor: '#a855f7', stopOpacity: 1}} />
                        <stop offset="100%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
                    </linearGradient>
                </defs>
            </svg>
            
             {/* 背景オーバーレイ */}
             <div className="hero-overlay"><img src={BG} alt="" className="hero-overlay" /></div>
            

            
             {/* デバイス画像 */}
             <img
                src={GoogleMap}
                alt="Googleマップ画面のモックアップ"
                className="hero-device hero-device--map"
                loading="lazy"
            />
            <img
                src={iPhone}
                alt="iPhoneアプリ画面のモックアップ"
                className="hero-device hero-device--phone"
                loading="lazy"
            />
            
            {/* Main content */}
            <div className="hero-content">
                <h1 className="hero-title">
                    金沢のまちに<br />
                    生きるWeb広告
                </h1>
                <p className="hero-subtitle">
                    あなたのビジネスをもっと輝かせる
                </p>
                <button className="hero-cta-button" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                    無料で相談する
                </button>
            </div>
        </section>
    );
};

export default Hero;
